import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';

const List = ({ t, onShowMessage, parentId, ...rest }) => {
	const columns = [
		{
			header: t('Common_Created'),
			accessor: 'created',
			sortable: false,
			cell: created => ui.formatDateTime(created)
		},
		{
			header: t('SentEmails_Center'),
			accessor: 'centerName',
			sortable: false
		},
		{
			header: t('SentEmails_Sender'),
			accessor: 'sender',
			cell: sender => sender || t('SentEmails_AutomaticSender'),
			sortable: false
		},
		{
			header: t('SentEmails_FromEmail'),
			accessor: 'fromEmail',
			sortable: false
		},
		{
			header: t('SentEmails_Reference'),
			accessor: 'reference',
			sortable: false
		}
	]
	if (!parentId || parentId === 0) {
		columns.push(
			{
				header: t('SentEmails_Parent'),
				accessor: 'parentId',
				sortable: false,
				cell: (parentId, row) => (<Link to={`/parents/${parentId}`} > {`${row.parentName} <${row.toEmail}>`}</Link>)
			})
	};
	columns.push(
		{
			header: t('SentEmails_Subject'),
			accessor: 'subject',
			sortable: false
		}
	);
	columns.push(
		{
			header: t('SentEmails_Message'),
			accessor: 'messageText',
			sortable: false,
			cell: messageText => <Button onClick={() => onShowMessage(messageText)} className='btn btn-teal'><FontAwesomeIcon icon={faEye} /> {t('Common_View')}</Button>
		}
	);

return (
	<Panel>
		<Panel.Body>
			<PagedEntitiesList columns={columns} {...rest} />
		</Panel.Body>
	</Panel>
);
};

export default withTranslation()(List);